import * as z from 'zod';
import { TFunction } from 'i18next';

export const requiredString = (t: TFunction) =>
  z.string({ error: t('register.validation.requiredField') }).min(1, t('register.validation.requiredField'));

export const trimmedString = (t: TFunction) =>
  z.preprocess(
    (val) => (typeof val === 'string' ? val.trim() : val),
    z.string({ error: t('register.validation.requiredField') }).min(1, t('register.validation.requiredField'))
  );

export const sanitizedString = (t: TFunction) =>
  z.preprocess(
    (val) => (typeof val === 'string' ? val.replace(/\s/g, '').toUpperCase() : val),
    z.string({ error: t('register.validation.requiredField') }).min(1, t('register.validation.requiredField'))
  );

export const requiredNumber = (t: TFunction) =>
  z.preprocess(
    (value) => {
      if (typeof value === 'string') {
        const trimmed = value.trim();
        return trimmed === '' ? Number.NaN : trimmed;
      }

      if (value === null || value === undefined) {
        return Number.NaN;
      }

      return value;
    },
    z.coerce
      .number({
        error: t('register.validation.requiredField'),
      })
      .refine((value) => !Number.isNaN(value), {
        error: t('register.validation.requiredField'),
      })
  );
